/**
 * Created by LIDA1FH on 07/11/2016.
 */
module.exports = function(bootstrap) {
    bootstrap.directive('tableListing', ["modal", "navigation", "brand", "services", "session", "$state", "$cookies", function(modal, navigation, brand, services, session, $state, $cookies) {
        return {
            controller: [ function() {
            }],
            link: function(scope, element, attrs, controller) {
                element.addClass('table-listing');
            }
        }
    }]);
    bootstrap.directive('tableListingHeader', ["modal", "navigation", "brand", "services", "session", "$state", "$cookies", function(modal, navigation, brand, services, session, $state, $cookies) {
        return {
            scope: {
                tableData: "="
            },
            replace: true,
            template: require('directives/hmhs/tableHeader.html'),
            link: function($scope) {
                $scope.sortStatus = 'descending';
                $scope.sortBy = function(propertyName) {
                    if(propertyName === undefined){
                        return;
                    }
                    $scope.tableData.reverse = ($scope.tableData.orderBy === propertyName) ? !$scope.tableData.reverse : false;
                    $scope.tableData.orderBy = propertyName;
                    $scope.sortStatus = $scope.tableData.reverse === true ? 'descending':'ascending';

                };

            }
        }
    }]);
}